import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { DataObject } from '@miq/shared-models';
import { isMasked } from '@miq/utils';
import { NgTemplateOutlet } from '@angular/common';
import { StopClickDirective } from '../../directives/stop-click.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
@Component({
  selector: 'miq-goes-to-record',
  templateUrl: 'goes-to-record.component.html',
  styleUrl: 'goes-to-record.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StopClickDirective, MatTooltip, RouterLink, NgTemplateOutlet, MatIcon],
})
export class GoesToRecordComponent {
  id = input<string>();
  type = input<string>();
  classes = input<string>();
  useIcon = input(false);
  urlParams = input<string[]>();
  toolTipMessage = input<string>();
  data = input<DataObject>(null);
  linkGenerator = input<(x: DataObject) => string[]>(null);
  dataParams = input(null);
  svgIconName = input('open_in_browser');
  target = input(null);
  public everythingOk = false;
  public internalParams: string[];
  constructor() {
    effect(() => {
      const data = this.data();
      const linkGenerator = this.linkGenerator();
      const urlParams = this.urlParams();
      const id = this.id();
      const type = this.type();
      if (data && linkGenerator) {
        this.internalParams = linkGenerator(data);
        this.everythingOk = Array.isArray(this.internalParams) && this.internalParams.every(val => val != null);
      } else {
        const validUrlParams = this.urlParamsValid(urlParams);
        const idTypeValid = this.idAndTypeValid(id, type);
        if (idTypeValid && !validUrlParams) {
          this.internalParams = ['/records', type, id, 'edit'];
          this.everythingOk = true;
        } else if (validUrlParams) {
          this.internalParams = urlParams;
          this.everythingOk = true;
        } else {
          this.everythingOk = false;
        }
      }
    });
  }
  private idAndTypeValid(id: string, type: string): boolean {
    if (!!id && !!type) {
      return !!id && !!type && !isMasked(id);
    } else {
      return false;
    }
  }
  private urlParamsValid(urlParams: string[]) {
    // in Clone/Create flows. Guard with Array.isArray and non-empty check to avoid runtime errors.
    if (urlParams === undefined || urlParams?.length === 0 || !Array.isArray(urlParams)) {
      return false;
    }
    if (urlParams.some(x => !!!x || x === 'undefined' || isMasked(x))) {
      return false;
    }
    return true;
  }
}
